import { render, staticRenderFns } from "./planoCircuitoInfantil.vue?vue&type=template&id=f595fb38&scoped=true"
import script from "./planoCircuitoInfantil.vue?vue&type=script&lang=js"
export * from "./planoCircuitoInfantil.vue?vue&type=script&lang=js"
import style0 from "./planoCircuitoInfantil.vue?vue&type=style&index=0&id=f595fb38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f595fb38",
  null
  
)

export default component.exports